const appConfig = {
  "name": "leave-supervisor-v2",
  "version": "0.1.0",
  "stage": "prod",
  "deployThisBuild": false,
  "okta": {
    "issuer": "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
    "clientId": "3jv6098s8o1jga8hrdpfm4hhk",
    "redirectUris": [
      "https://leave-supervisor-v2.atlas-apps.mit.edu"
    ],
    "postLogoutRedirectUris": [
      "https://leave-supervisor-v2.atlas-apps.mit.edu/logout"
    ],
    "scopes": [
      "address",
      "digital-id/search",
      "digital-id/user",
      "email",
      "feature/user",
      "offline_access",
      "openid",
      "phone",
      "profile",
      "sap-proxy/execute-rfc",
      "sap-proxy/function",
      "sap-proxy/status",
      "user/all"
    ]
  },
  "amplify": {
    "userPoolId": "us-east-1_bCu6BU8d2",
    "userPoolWebClientId": "3jv6098s8o1jga8hrdpfm4hhk",
    "oauth": {
      "domain": "atlas-auth.mit.edu",
      "scope": [
        "digital-id/search",
        "digital-id/user",
        "feature/user",
        "openid",
        "profile",
        "sap-proxy/function",
        "sap-proxy/status"
      ],
      "redirectUris": [
        "https://leave-supervisor-v2.atlas-apps.mit.edu"
      ],
      "postLogoutRedirectUris": [
        "https://leave-supervisor-v2.atlas-apps.mit.edu/logout"
      ],
      "responseType": "token",
      "options": {
        "AdvancedSecurityDataCollectionFlag": false
      }
    }
  }
};
export default appConfig;